module.exports = __webpack_public_path__ + "static/assets/605de00c0d558339efa3bbc72ba44d5c.png";